import {
  Breadcrumb,
  Button,
  Input,
  PageHeader,
  Form,
  Row,
  Col,
  Popconfirm,
  Select,
  message,
} from "antd";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Page from "_components/Page";
import { workItemService, taskService } from "_services";

function Add({ history }) {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [form] = Form.useForm();
  const { Option } = Select;
  const [jobTasks, setJobTasks] = useState([]);

  useEffect(() => {
    getJobTasks();
  }, []);

  const getJobTasks = () => {
    taskService
      .getSuggestion()
      .then((x) => {
        setJobTasks(x.content);
      })
      .catch((errorInfo) => {
        message.error(`${errorInfo}`);
      });
  };

  const handleFormSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const payload = {
          ...values,
          jobTasks: values.jobTasks.map((taskId) => {
            const selectedTask = jobTasks.find((task) => task.id === taskId);
            return {
              id: selectedTask.id,
              code: selectedTask.code,
              name: selectedTask.name,
            };
          }),
        };
        setIsLoading(true);
        workItemService
          .create(payload)
          .then(() => {
            setIsLoading(false);
            message.success("Work Item created successfully!");
            history.push("/work-items");
          })
          .catch((error) => {
            setIsLoading(false);
            setError(error);
            message.error(`Error: ${error.message}`);
          });
      })
      .catch((errorInfo) => {
        message.error(`Validation failed: ${errorInfo}`);
      });
  };

  const getActionButtons = () => {
    return [
      <Popconfirm
        key="1"
        title="Are you sure to create this work item?"
        onConfirm={handleFormSubmit}
      >
        <Button type="primary" htmlType="submit" loading={isLoading}>
          Save
        </Button>
      </Popconfirm>,
      <Button key="2" htmlType="button" onClick={onCancel}>
        Cancel
      </Button>,
    ];
  };

  const onCancel = () => {
    history.push("/work-items");
  };

  return (
    <div>
      <PageHeader
        title={
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/dashboard">Dashboard</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/work-items">Work Item Search</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to="/work-items/add">New Work Item</Link>
            </Breadcrumb.Item>
          </Breadcrumb>
        }
        extra={getActionButtons()}
      >
        <Page inner error={error}>
          <Form
            layout="vertical"
            form={form}
            name="form-create"
            requiredMark={false}
          >
            <Row gutter={24}>
              <Col span={8}>
                <Form.Item
                  name="code"
                  label="Code"
                  rules={[{ required: true, message: "Code is required." }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="name"
                  label="Name"
                  rules={[{ required: true, message: "Name is required." }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="jobTasks"
                  label="Job Tasks"
                  rules={[
                    { required: true, message: "At least one Job Task is required" },
                  ]}
                >
                  <Select
                    mode="multiple"
                    placeholder="Please select Job Tasks"
                    allowClear
                  >
                    {jobTasks.map((task) => (
                      <Option value={task.id} key={task.id}>
                        {task.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Page>
      </PageHeader>
    </div>
  );
}

export default Add;
